import React, { useEffect, useState } from 'react';

import { FlexDiv, GenericP } from 'commonStyles';
import RadioBtn from 'common/RadioBtn/index';

function BottomRadioField({ field = {}, isMobile, value, key, handleSelection }) {
	const { options, label } = field;

	const [radiovalue, setRadiovalue] = useState(value);

	useEffect(() => {
		setRadiovalue(value);
	}, [value]);

	const handleChange = (data = {}) => () => {
		field.value = data;
		setRadiovalue(data.value);
		handleSelection && handleSelection(key, data.value);
	};

	return (
		<FlexDiv directionInMobile='column' top_M='16'>
			{isMobile && <GenericP bottom_M='8'>{label}</GenericP>}
			{options && options.map((item, index) => (
				<RadioBtn
					RadioText={item.label}
					infoText={item.infoText}
					name={item.name}
					isChecked={item.value === radiovalue}
					key={index}
					changeHandler={handleChange(item)}
					value={item.value}
					customStyle={isMobile ? 'mice' : 'mice-desktop'}
				/>
			))}
		</FlexDiv>
	);
}

export default BottomRadioField;
